
// export const BASE_URL= (isProd) ? "https://be.selectbrands.in/api":"http://localhost:8000/api" ;

export const BASE_URL = "https://be.selectbrands.in/api";



// export const BASE_URL = "http://192.168.2.56:8000/api";
